(() => {
  const badgeSelector = '.wl-header-badge[data-wishlist-count]';

  function getBadgeCount(badge) {
    const value = Number.parseInt((badge.textContent || '').trim(), 10);
    return Number.isFinite(value) ? value : 0;
  }

  function syncWishlistBadge(badge) {
    const count = getBadgeCount(badge);
    const isVisible = count > 0;

    badge.dataset.countVisible = isVisible ? 'true' : 'false';
    badge.classList.toggle('cart-count--ellipse', count > 9);

    if (isVisible && badge.style.display === 'none') {
      badge.style.display = '';
    }
  }

  function syncAllWishlistBadges() {
    document.querySelectorAll(badgeSelector).forEach(syncWishlistBadge);
  }

  function watchWishlistBadge(badge) {
    if (badge.dataset.mysticBadgeWatched === 'true') return;

    badge.dataset.mysticBadgeWatched = 'true';
    syncWishlistBadge(badge);

    new MutationObserver(() => syncWishlistBadge(badge)).observe(badge, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  function initWishlistBadges() {
    document.querySelectorAll(badgeSelector).forEach(watchWishlistBadge);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistBadges, { once: true });
  } else {
    initWishlistBadges();
  }

  window.addEventListener('pageshow', syncAllWishlistBadges);

  new MutationObserver(initWishlistBadges).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
